(() => {
  const POPOVER_ID = 'ft-cart-popover';
  const ACTIVE_CLASS = 'is-active';
  const BUSY_CLASS = 'is-loading';
  let hideTimer;

  const getCartLink = () => document.getElementById('cart-icon-bubble');

  const getMessage = () => {
    const heading = document.querySelector('#cart-notification .cart-notification__heading');
    const text = heading?.textContent?.replace(/\s+/g, ' ').trim();
    return text || 'Item added to your cart';
  };

  const getViewCartText = () => {
    const button = document.getElementById('cart-notification-button');
    const text = button?.textContent?.replace(/\s+/g, ' ').trim();
    return text || 'View cart';
  };

  const ensurePopover = () => {
    let popover = document.getElementById(POPOVER_ID);
    const cartLink = getCartLink();
    const host = cartLink?.parentElement || document.body;

    if (!popover) {
      popover = document.createElement('div');
      popover.id = POPOVER_ID;
      popover.className = 'ft-cart-popover';
      popover.setAttribute('role', 'status');
      popover.setAttribute('aria-live', 'polite');
      popover.hidden = true;
      popover.innerHTML = `
        <div class="ft-cart-popover__icon" aria-hidden="true">✓</div>
        <div class="ft-cart-popover__body">
          <strong class="ft-cart-popover__title"></strong>
          <span class="ft-cart-popover__product"></span>
          <a class="ft-cart-popover__link" href="${window.routes?.cart_url || '/cart'}"></a>
        </div>
      `;
      host.appendChild(popover);
    } else if (cartLink && popover.parentElement !== host) {
      host.appendChild(popover);
    }

    const link = popover.querySelector('.ft-cart-popover__link');
    if (link) {
      link.href = window.routes?.cart_url || '/cart';
      link.textContent = getViewCartText();
    }

    const title = popover.querySelector('.ft-cart-popover__title');
    if (title) title.textContent = getMessage();

    return popover;
  };

  const showPopover = ({ title, error } = {}) => {
    const popover = ensurePopover();
    const product = popover.querySelector('.ft-cart-popover__product');

    popover.classList.toggle('is-error', Boolean(error));
    const titleNode = popover.querySelector('.ft-cart-popover__title');
    if (titleNode) titleNode.textContent = error ? error : getMessage();
    if (product) {
      product.textContent = error ? '' : title || '';
      product.hidden = !title || Boolean(error);
    }

    clearTimeout(hideTimer);
    popover.hidden = false;
    requestAnimationFrame(() => popover.classList.add(ACTIVE_CLASS));
    hideTimer = setTimeout(() => {
      popover.classList.remove(ACTIVE_CLASS);
      setTimeout(() => {
        if (!popover.classList.contains(ACTIVE_CLASS)) popover.hidden = true;
      }, 220);
    }, error ? 4800 : 3200);
  };

  const getSectionHTML = (html) => {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.shopify-section') || doc.body;
  };

  const updateCartIcon = async (sections) => {
    let cartIconHTML = sections?.['cart-icon-bubble'];

    if (!cartIconHTML) {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-icon-bubble`);
      cartIconHTML = await response.text();
    }

    const wrapper = getSectionHTML(cartIconHTML);
    const cartLink = getCartLink();
    if (!wrapper || !cartLink) return;

    const nextIcon = wrapper.querySelector('.svg-wrapper');
    const currentIcon = cartLink.querySelector('.svg-wrapper');
    if (nextIcon && currentIcon) currentIcon.replaceWith(nextIcon.cloneNode(true));

    const nextBubble = wrapper.querySelector('.cart-count-bubble');
    const currentBubble = cartLink.querySelector('.cart-count-bubble');
    if (currentBubble) currentBubble.remove();
    if (nextBubble) cartLink.appendChild(nextBubble.cloneNode(true));
  };

  const titleFromForm = (form) => {
    const card = form.closest('[data-ft-product-card]');
    const cardTitle = card?.dataset?.ftItemName || card?.querySelector('.ft-product-card__title')?.textContent;
    if (cardTitle) return cardTitle.replace(/\s+/g, ' ').trim();

    const heading = document.querySelector('.product__title h1, h1');
    return heading?.textContent?.replace(/\s+/g, ' ').trim() || '';
  };

  const setFormBusy = (form, busy) => {
    const button = form.querySelector('button[type="submit"], button[name="add"]');
    if (!button) return;
    button.toggleAttribute('aria-disabled', busy);
    button.classList.toggle(BUSY_CLASS, busy);
  };

  const addWithAjax = async (form) => {
    const formData = new FormData(form);
    formData.append('sections', 'cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    const response = await fetch(window.routes?.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });
    const parsed = await response.json();

    if (!response.ok || parsed.status) {
      throw new Error(parsed.description || parsed.message || window.cartStrings?.error || 'Could not add to cart');
    }

    return parsed;
  };

  const handleSubmit = async (event) => {
    const form = event.target?.closest?.('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (form.closest('product-form')) return;
    if (form.querySelector('[name="return_to"]')) return;

    event.preventDefault();

    setFormBusy(form, true);
    try {
      const parsed = await addWithAjax(form);
      await updateCartIcon(parsed.sections);
      if (window.publish && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'ft-cart-popover',
          productVariantId: form.querySelector('[name="id"]')?.value,
          cartData: parsed,
        });
      }
      showPopover({ title: titleFromForm(form) });
    } catch (error) {
      showPopover({ error: error.message || window.cartStrings?.error });
    } finally {
      setFormBusy(form, false);
    }
  };

  const patchCartNotification = () => {
    customElements.whenDefined('cart-notification').then(() => {
      const CartNotification = customElements.get('cart-notification');
      if (!CartNotification || CartNotification.prototype.ftCartPopoverPatched) return;

      CartNotification.prototype.ftCartPopoverPatched = true;
      CartNotification.prototype.renderContents = function renderContents(parsedState) {
        this.cartItemKey = parsedState.key;
        updateCartIcon(parsedState.sections).then(() => {
          showPopover({ title: parsedState.product_title || parsedState.title });
        });
      };
    });
  };

  document.addEventListener('submit', handleSubmit, true);
  document.addEventListener('DOMContentLoaded', ensurePopover);
  patchCartNotification();

  window.ftCartPopover = {
    ensurePopover,
    show: showPopover,
    updateCartIcon,
  };
})();
